// Angular Modules
import { Injectable }              from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
// Services
import { ApiService }              from '../../root-services/api.service';
// RxJS Modules
import { Observable }              from 'rxjs/Observable';


@Injectable()
export class ImageService {
  private awsUrl1: string = '/actions/authorise_image_upload';

  constructor(
    private http: Http,
    private apiService: ApiService
  ) { }

  public postImage(body: any, file: File): Observable<any> {
    const imageData = { key: '' , location: ''};
    return this.apiService.post(this.awsUrl1, body)
                          .map((res: Response) => {
                            const data = res.json();
                            const upload_url = data.upload_url;
                            const form = this.buildForm(data, file);
                            const headers = new Headers();
                            imageData.key = data.key;
                            headers.append('Content-Type', 'multipart/form-data');
                            if (data.fields['x-amz-security-token']) {
                              headers.append('x-amz-security-token', data.fields['x-amz-security-token']);
                            }
                            return { upload_url, form, headers };
                          })
                          .flatMap((obj) => this.http.post(obj.upload_url, obj.form))
                          .map((res: Response) => {
                            imageData.location = res.headers.get('location');
                            return imageData;
                          })
                          .publishReplay(1).refCount()
                          .catch(this.handleError);
  }

  private buildForm(data: any, file: File): FormData {
    const formData: FormData = new FormData();
    formData.append('Content-Type', data.fields['Content-Type']);
    formData.append('bucket', data.fields.bucket);
    formData.append('key', data.fields.key);
    formData.append('policy', data.fields.policy);
    formData.append('x-amz-algorithm', data.fields['x-amz-algorithm']);
    formData.append('x-amz-credential', data.fields['x-amz-credential']);
    formData.append('x-amz-date', data.fields['x-amz-date']);
    formData.append('x-amz-signature', data.fields['x-amz-signature']);

    if (data.fields.acl) {
      formData.append('acl', data.fields.acl);
    }
    if (data.fields['x-amz-security-token']) {
      formData.append('x-amz-security-token', data.fields['x-amz-security-token']);
    }
    // File must be appended last
    formData.append('file', file);

    return formData;
  }

  private handleError(error: any): Promise<any> {
    console.error('An Error Occurred:', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/image.service.ts